import { Button, Input, Space } from "antd";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";

export default function ProjectsToolbar({
  search,
  onSearchChange,
  onRefresh,
  onCreate,
  isManager,
}) {
  return (
    <div className="projects-toolbar">
      <Input.Search
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search projects..."
        allowClear
        style={{ width: 300 }}
      />
      <Space>
        {isManager && (
          <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
            New Project
          </Button>
        )}
        <Button icon={<ReloadOutlined />} onClick={onRefresh}>
          Refresh
        </Button>
      </Space>
    </div>
  );
}
